import { LayoutView } from "marionette";
import ReactDOM from "react-dom/client";
import TargetLayout from "src/modules/wizards/target/components/target-layout/target-layout";
import WizardProvider from "src/modules/wizards/wizard-context";
import { isAppPresent } from "src/modules/wizards/app-wizards";
import navigateTo from "src/navigate-to";
import growl from "app/components/common/growl";

class TargetWizard {
    constructor(predefinedComponentName, getCustomAdapterProperties, stepName, prefillWizardData) {
        this.View = this.getView().extend({
            predefinedComponentName,
            getCustomAdapterProperties,
            stepName,
            prefillWizardData
        });
    }

    get() {
        return {
            View: this.View
        };
    }

    getView() {
        const TargetWizard = LayoutView.extend({
            template: _.template(""),
            predefinedComponentName: null,
            initialize: function(options) {
                this.options = options;
            },
            onRender: function() {
                const appPresent = isAppPresent(this.options.appName);
                if (!appPresent) {
                    growl.error(`The application ${this.options.appName} was not found`, "App not found");
                    navigateTo.Apps();
                    return;
                }
                const root = ReactDOM.createRoot(this.$el[0]);
                root.render(
                    <WizardProvider>
                        <TargetLayout target={this.predefinedComponentName} {...this.options} />
                    </WizardProvider>
                );
            }
        });
        return TargetWizard;
    }
}

export default TargetWizard;
